export function setHeight() {
    // const height = document.body.scrollHeight;
    const height = window.screen.availHeight;
    window.parent.postMessage({ height: height - 280 }, process.env.VUE_APP_ZGZX_POSTMESSAGE_URL);
}